/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import {
  CreateCourtBookingEndUser,
  CustomerCourtBookingAmount,
  CustomerCourtBookingRescheduleAmount,
  CustomerCourtBookingRescheduling,
} from "../../../utilities/api/courtBooking";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const CustomerCourtBookingSummary = (props: any) => {
  let {
    courtBookingData,
    setCourtBookingData,
    isReschedule = false,
    slotId,
  } = props;
  const navigate = useNavigate();
  const { AllSportsData  , sportErrorMessage} = useAppSelector((state) => state.sportList);
  const { AllFacilitiesData, errorMessage } = useAppSelector((state) => state.facilityList);
  const { UserProfileDetails , profileErrorMessage} = useAppSelector((state) => state.profileDetail);
  const [amount, setAmount] = useState({}) as any;
  const [submitButton, setSubmitButton] = useState(false);
  const [totalTax, setTotalTax] = useState(0);
  const sportName = AllSportsData.find(
    (item: any) => item.id == courtBookingData?.sportId
  )?.name as string;

  if (errorMessage || profileErrorMessage || sportErrorMessage) {
    toast.error(errorMessage.message)
  }

  const facilityName = AllFacilitiesData.find(
    (item: any) => item.id == courtBookingData?.facilityId
  )?.name as string;

  const GetAmount = async () => {
    if (!courtBookingData?.courtId || parseInt(courtBookingData?.courtId) <= 0) {
      toast.error("Invalid court selection");
      return;
    }
    let _amount: any;
    let selectedSlots: any = courtBookingData?.selectedSlots.map(
      (slots: any) => {
        return {
          id: slotId,
          fromTime: slots.fromTime,
          toTime: slots.toTime,
          bookingDate: slots.bookingDate,
        };
      }
    );
    if (!isReschedule) {
      let payload = {
        facilityId: courtBookingData?.facilityId,
        sportId: courtBookingData?.sportId,
        courtId: parseInt(courtBookingData?.courtId),
        selectedSlots: selectedSlots,
        isIgstTax: "false",
      };
      _amount = await CustomerCourtBookingAmount(payload);
    } else {
      let Payload = {
        selectedSlots: selectedSlots,
        courtId: parseInt(courtBookingData?.courtId),
        cancelledSlots: [],
      };
      _amount = await CustomerCourtBookingRescheduleAmount(
        courtBookingData.id,
        Payload
      );
    }
    if (_amount.status === 200) {
      setAmount(_amount.data.data);
      let getTotalTax = 0;

      _amount.data.data?.bookingTaxes.forEach((_tax: any) => {
        getTotalTax += _tax?.percentage;
      });

      setTotalTax(getTotalTax);
    } else {
      setAmount(_amount.response?.data?.data);
      toast.error(_amount.response.data.message);
    }
  };

  useEffect(() => {
    GetAmount();
  }, []);

  const handleBooking = async () => {
    setSubmitButton(true);

    let selectedSlots: any = courtBookingData.selectedSlots.map(
      (slots: any) => {
        return {
          id: slotId,
          fromTime: slots.fromTime,
          toTime: slots.toTime,
          bookingDate: slots.bookingDate,
        };
      }
    );

    if (!isReschedule) {
      const bookingPayload = {
        ...courtBookingData,
        courtId: parseInt(courtBookingData.courtId),
        selectedSlots: selectedSlots
      };

      const _booking = await CreateCourtBookingEndUser(bookingPayload);
      if (_booking.status === 200) {
        if (!_booking.data.data.paymentLink.length)
          navigate("/customer-court-booking-details", {
            state: _booking.data.data.id,
          });
        else {
          const url = _booking.data.data.paymentLink;
          const link = document.createElement("a");
          link.href = url;
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
        }
      } else {
        toast.error(_booking.response.data.message);
      }
      setSubmitButton(false);
    } else {
      let payload = {
        selectedSlots: selectedSlots,
        courtId: parseInt(courtBookingData?.courtId),
        cancelledSlots: [],
      };

      const _reschedule = await CustomerCourtBookingRescheduling(
        courtBookingData.id,
        payload
      );
      if (_reschedule.status === 200) {
        if (!_reschedule.data.data.paymentLink.length)
          navigate("/customer-court-booking-details", {
            state: courtBookingData.id,
          });
        else {
          const url = _reschedule.data.data.paymentLink;
          const link = document.createElement("a");
          link.href = url;
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
        }
      } else {
        toast.error(_reschedule.response.data.message);
      }
      setSubmitButton(false);
    }
    setSubmitButton(false);
  };

  const handleChecked = (checked: any) => {
    checked
      ? setCourtBookingData({
        ...courtBookingData,
        paymentMethod: "rewardPoints",
      })
      : setCourtBookingData({ ...courtBookingData, paymentMethod: "online" });
  };

  return (
    <>
      <Container fluid className="g-0">
        <Row>
          <h4 className="fs-5 fw-semibold mb-4 text-start">Booking Summary</h4>
          <Col lg={6}>
            <div className="coach-booking-details">
              <Row className="text-start row-mb">
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Facility Name
                  </span>
                  <span className="user-info">{facilityName}</span>
                </Col>
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Sports
                  </span>
                  <span className="user-info">{sportName}</span>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={6}>
            <table className="table table-bordered table-sm ">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {courtBookingData?.selectedSlots?.map((item: any) => {
                  return (
                    <tr key={item.fromTime}>
                      <td>{item.bookingDate?.split("-").reverse().join("/")}</td>
                      <td>
                        {item.fromTime} to {item.toTime}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
        </Row>
        <Row className="text-end">
          <hr />
          {!isReschedule ? (
            <>
              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">Sub Total : </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span> {amount?.subTotal?.toFixed(2)}
                </span>
              </Col>
              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">
                  Total Tax({totalTax}%) :{" "}
                </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span> {amount?.totalTax?.toFixed(2)}
                </span>
              </Col>

              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">
                  Payable Amount :{" "}
                </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span> {Math.round(amount?.totalAmount)}
                </span>
              </Col>
            </>
          ) : (
            <>
              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">Sub Total : </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span> {amount?.subTotal?.toFixed(2)}
                </span>
              </Col>
              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">
                  Total Tax({totalTax}%) :{" "}
                </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span> {amount?.totalTax?.toFixed(2)}
                </span>
              </Col>
              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">
                  Reschedule Slot Amount:{" "}
                </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span> {amount?.totalAmount?.toFixed(2)}
                </span>
              </Col>
              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">
                  Previous Billing Amount:{" "}
                </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span>{" "}
                  {amount?.prevTotalAmount?.toFixed(2)}
                </span>
              </Col>
              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">
                  Already Paid:{" "}
                </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span>{" "}
                  {amount?.prevTotalPaidAmount?.toFixed(2)}
                </span>
              </Col>
              <Col md={{ span: 4, offset: 8 }}>
                <span className="user-info-title text-info text-uppercase mb-2">
                  Revised Amount Need to Pay:{" "}
                </span>
                <span className="user-info">
                  <span className="rupees-symbol">&#8377;</span>{" "}
                  {Math.round(amount?.totalPayableAmount)}
                </span>
              </Col>
            </>
          )}
          <Col lg={12}>
            <span className="d-block fst-italic fw-semibold">
              <sup>*</sup>The Amount is inclusive of all the taxes
            </span>
          </Col>
          {Number(UserProfileDetails?.availableRewardPoints) >= Number(amount?.totalAmount) && (
            <>
              <Col
                md={{ span: 3, offset: 9 }}
                className="border-top col-md-3 mt-3 offset-md-9 pt-3 text-end"
              >
                <span className="user-info-title text-info text-uppercase mb-2 fw-semibold">
                  Available Rewards Points :{" "}
                </span>
                <span className="text-primary fw-semibold">
                  {UserProfileDetails?.availableRewardPoints}
                </span>
                <Form.Check
                  className="d-inline-block fw-semibold"
                  onChange={(e: any) => handleChecked(e.target.checked)}
                  checked={courtBookingData?.paymentMethod === "rewardPoints"}
                  label="Pay with Rewards Points"
                  name="rewards-point"
                  type="checkbox"
                  id="rewards-point"
                />
              </Col>
            </>
          )}
        </Row>
        <hr />
        <Row>
          <Col lg={12} className="text-end">
            <Button
              onClick={handleBooking}
              disabled={submitButton}
              type="button"
              bname={submitButton ? "Submitting" : "Proceed to Pay"}
              name="pay"
              id="pay"
              className="btn btn-primary rounded-1"
            ></Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export { CustomerCourtBookingSummary };
